import { Button } from '@televet/kibble-ui/build/components/Button';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Box, BoxProps, Flex } from '@televet/kibble-ui/build/chakra';
import React from 'react';

const variants = {
  lineBgColor: {
    valid: 'background.light',
    warning: 'border.warning',
    invalid: 'border.danger',
  } as Record<string, BoxProps['bgColor']>,
};

export enum CampaignSummaryElementState {
  Valid = 'valid',
  Warning = 'warning',
  Invalid = 'invalid',
}

type CampaignSummaryElementProps = {
  state: CampaignSummaryElementState;
  border: string;
  borderColor: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  showButton?: boolean;
  buttonText?: string;
  children: JSX.Element;
  title: string;
  subTitle?: JSX.Element;
  invalidText?: string;
};

export const CampaignSummaryElement = ({
  title,
  state,
  border,
  borderColor,
  showButton,
  onClick,
  buttonText,
  invalidText,
  children,
}: CampaignSummaryElementProps): JSX.Element => {
  return (
    <Flex borderBottom={border} borderColor={borderColor} justifyContent="space-between" padding="2">
      <Flex flex="1" paddingLeft="2">
        <Box ml="-8px" mr="8px" borderRadius="4px" bgColor={variants.lineBgColor[state]} width={1} />
        <Box minWidth={6} minHeight={6} paddingY={2}>
          {state === CampaignSummaryElementState.Valid ? (
            <Icon size="lg" name="checkmarkCircle" variant="success" />
          ) : (
            <Icon
              size="lg"
              name="alertCircle"
              variant={state === CampaignSummaryElementState.Invalid ? 'danger' : 'warning'}
            />
          )}
        </Box>
        <Box width="100%" ml="2" paddingY="2">
          <Text as="p" fontWeight="bold" fontSize="xl">
            {title}
          </Text>
          {children}
          {state === CampaignSummaryElementState.Invalid && !!invalidText && (
            <Text as="p" mt="2" mb="2" color="text.danger">
              {invalidText}
            </Text>
          )}
        </Box>
      </Flex>
      {showButton && (
        <Button margin="3" onClick={onClick} variant="secondary">
          {buttonText}
        </Button>
      )}
    </Flex>
  );
};
